import { useTranslation } from "react-i18next";
import { Button, Img, Text } from "components";
import Footer from "components/Footer";
import { useNavigate, useParams } from "react-router-dom";
import Confetti from "react-confetti";
import { useDispatch, useSelector } from "react-redux";
import { getAuth } from "../../../redux/reducers/loginData";
import { useEffect } from "react";
import { changeTrigger } from "redux/reducers/trigger";
import { updateOrderData } from "redux/reducers/orderData";
import { setSnackbar } from "../../../redux/reducers/snackbar";
import { getOrderData } from "redux/reducers/orderData";
import { trackPurchase } from "utils/helper/custom";

const CartSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let { slug } = useParams();
  const auth = useSelector(getAuth);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get('type');
  const orderData = useSelector(getOrderData);
  
  /**
   *  Function to copy order Number
   */
    const copyText = (textToCopy) => {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999); 
      document.execCommand('copy');
      document.body.removeChild(textarea);
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: 'Text copied to clipboard',
          snackbarState: "success",
        })
      );
    };

  useEffect(() => {
    dispatch(updateOrderData({}));
    dispatch(changeTrigger("fetchCartCount"));
    window.scrollTo(0, 0); // Scrolls to the top of the page
    trackPurchase({
      transaction_id: slug,
      revenue: orderData?.total_amount || 0,
      items: orderData?.items || []
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      
      <div
        className="relative flex flex-col items-center justify-center min-h-screen w-full overflow-hidden"
        style={{ backgroundColor: "#FDF8F3" }}
      >
        <Confetti className="w-full h-full absolute top-0 left-0 z-0 pointer-events-none" />

        <Img
          src="/images/successCartBG.png"
          alt="background decoration"
          className="absolute inset-0 w-full h-full object-cover opacity-40 pointer-events-none z-0"
        />

        <div className="relative z-10 flex flex-col items-center justify-center px-6 text-center max-w-[860px] mx-auto mb-5">

          <div className="mb-2 relative">
            <Img
              src="/images/cartSuccess.png"
              alt="success heart"
              className="h-[264px] w-[248px] object-cover mx-auto sm:w-[144px] sm:h-[153px]"
            />
          </div>

          <h1
            className="text-[32px] leading-[48px] font-semibold text-center mb-4 sm:text-[24px] leading-[32px]"
            style={{
              color: "var(--Blacks-900, #1A1A1A)",
              fontFamily: "Unbounded",
              fontStyle: "normal",
            }}
          >
            {t("orderHasBeenPlaced")}
          </h1>

          <p
            className="text-[20px] leading-[28px] font-normal text-center mb-8 px-2 py-2 sm:text-[16px]"
            style={{
              color: "var(--Blacks-400, #727783)",
              fontFamily: "Inter",
              fontStyle: "normal",
            }}
          >
            {t("thankYouYourOrderOrderID") || "Thank You. Your order"}{" "}
            
            <span
              className="cursor-pointer hover:underline"
              onClick={() => {
                copyText(slug);
              }}
              style={{
                color: "var(--Blacks-900, #1A1A1A)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: 400,
                lineHeight: "28px",
              }}
            >
              {slug}
            </span>{" "}
            
            <span
              style={{
                color: "var(--Blacks-900, #727783)",
              }}
            >
              {t("hasBeenPlacedForFurtherInformationVisitYourOrdersOrYouCanContinueShopping") ||
                "has been placed. For further information visit your orders or you can continue shopping."}
            </span>
          </p>

          <div className="flex flex-row sm:flex-col gap-4 items-center justify-center w-full max-w-[700px]">

            {auth?.id != 0 ? (
              <button
                onClick={() => { navigate("/my-order"); }}
                className="w-full sm:flex-1 
                          flex items-center justify-center gap-[10px]
                          h-[48px] px-[40px] py-[12px]
                          rounded-full border border-[#727783] 
                          bg-white text-[#1A1A1A] text-[16px] font-semibold 
                          hover:bg-gray-50 transition-colors cursor-pointer"
                style={{ fontFamily: "Unbounded" }}
              >
                {t("myOrders") || "My Orders"}
              </button>
            ) : null}

            <button
              onClick={() => { navigate("/"); }}
              className="w-full sm:flex-1
                        flex items-center justify-center gap-[10px]
                        h-[48px] px-[40px] py-[12px]
                        rounded-full bg-[#771237] text-[white] 
                        text-[16px] font-semibold 
                        hover:bg-[#5e0e2c] transition-colors cursor-pointer"
              style={{ fontFamily: "Unbounded" }}
            >
              {t("continueShopping")}
            </button>

          </div>

        </div>
        <Footer className="absolute bottom-[0] flex font-nunitoregular inset-x-[0] items-center justify-center mx-auto w-full" />
      </div>
    </>
  );
};

export default CartSuccess;
